<template>
  <div v-show="tableDisplay == 'initiate_documents'">
    <v-row style="margin-top: -90px">
      <v-spacer></v-spacer>
      <v-col cols="3" class="text-right"> 
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details>
          <template slot="append-outer">
          <dropdown-filter @applyFilter="applyFilter"/>
          </template>
        </v-text-field>
      </v-col>
      <!-- <v-col cols="12" class="text-right">
        <v-btn
          color="primary"
          dark
          rounded
          small
          class="mx-2"
          @click="dialog = true"
        >
          Create Document Type
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col> -->
    </v-row>
    <v-row class="mb-1 px-3" v-if="selected.length > 0">
      <v-app-bar color="grey darken-3" dense dark>
        <v-toolbar-title class="overline"
          >{{ selected.length }} selected</v-toolbar-title
        >
        <v-divider class="mx-4" vertical></v-divider>
        <!-- <v-btn
          depressed
          class="overline mx-4 custom-hover"
          color="grey darken-3"
          @click="assignToRoutee()"
          >Assign To Route</v-btn
        > -->
        <v-btn
          depressed
          class="overline mx-4 custom-hover"
          color="grey darken-3"
          @click="rejectDialog = true"
          >Reject</v-btn
        >
      </v-app-bar>
    </v-row>
    <v-row class="mt-0 mb-0" v-if="showSuccess">
      <v-col cols="12" class="mb-n7">
        <v-alert dense text type="success" dismissible>Saved Document</v-alert>
      </v-col>
    </v-row>
    <v-row class="mt-0 mb-0" v-if="showRouteSuccess">
      <v-col cols="12" class="mb-n7">
        <v-alert dense text type="success" dismissible
          >Saved Route Record</v-alert
        >
      </v-col>
    </v-row>
    <RouteModalCreate
      :dialog="route_dialog"
      :fromDocument="true"
      @closeDialog="closeRouteDialog"
    />
    <v-row class="mt-12">
      <v-col>
        <v-data-table
          v-model="selected"
          :single-select="false"
          :items="allRoutePendingDocuments"
          :headers="headers"
          :items-per-page="10"
          class="elevation-2"
          item-key="id"
          :search="search"
          show-select
          @contextmenu:row="show"
          :loading="isFetching || isFetchingg"
          loading-text="Loading... Please wait"
        >
        <template v-slot:[`item.request_date`]="{ item }">
          <span>{{ item.route_request_date ? `${formatDate(item.route_request_date)} ( ${compareDateFromNow(item.route_request_date)} )` : ""}}</span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              
            <v-icon small class="mr-2" @click="assignToRoute(item)" 
                v-bind="attrs"
                v-on="on">mdi-pencil</v-icon>
            </template>
            <span>Assign To Route</span>
          </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <loading-overlay v-if="loading"/>
    <RejectModal 
      :dialog="rejectDialog"
      :selected="selected"
      @closeDialog="closeRejectDialog"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import RouteModalCreate from "../RouteCreateModal";
import LoadingOverlay from "../common/LoadingOverlay.vue";
import DropdownFilter from "../documents/DropdownFilter.vue"
import RejectModal from "./modal/RejectModal.vue"
import _ from "lodash";
import moment from 'moment'
export default {
  name: "PendingDocuments",
  props: {
    tableDisplay: String,
    // search: String,
    isFetching: Boolean
  },
  components: {
    RouteModalCreate,
    LoadingOverlay,
    DropdownFilter,
    RejectModal
  },
  data() {
    return {
      rejectDialog: false,
      isFetchingg: false,
      search: "",
      loading: false,
      showMenu: false,
      x: 0,
      y: 0,
      selected: [],
      documents: [],
      singleSelect: false,
      headers: [
        // {
        //   text: "Name",
        //   align: "start",
        //   sortable: true,
        //   value: "name",
        // },
        // { text: "Title", value: "title" },
        { text: "Subject", value: "subject" },
        { text: "Route Request Date", value: "request_date"},
        { text: "Sender", value: "sender" },
        { text: "Type", value: "type" },
        { text: "Category", value: "document_category.name" },
        { text: "Actions", value: "actions", align: "center" },
        // { text: "Address", value: "address" },
      ],
      showSuccess: false,
      dialog: false,
      updateItem: null,
      route_dialog: false,
      showRouteSuccess: false,
      dateRange: {
          startDate: '',
          endDate: '',
        },
      category: [],
      types: [],
    };
  },
  methods: {
    ...mapActions([
      "attachDocuments",
      "addInitiatedFromRoute",
      "initiateDocumentRouteRequest",
      "filterPendingInitiateDocuments",
      "fetchFilteredPendingDocuments"
    ]),
    fetch: _.debounce(async function() {
        this.isFetching = true
      let payload = {
        dateRange:
          this.dateRange.startDate != "" && this.dateRange.endDate != ""
            ? this.dateRange
            : { startDate: "January 01 , 1680", endDate: moment() },
        category: this.category,
        type: this.types,
      };
      await this.fetchFilteredPendingDocuments(payload).then(()=>{
        this.isFetching = false
      })
    }, 300),
    applyFilter(filters){
        this.category = filters.category
        this.types = filters.types
        this.dateRange.startDate = filters.dateRange.startDate
        this.dateRange.endDate = filters.dateRange.endDate
        this.fetch()
    },
    formatDate(date){
      return moment(date).format('MMMM DD YYYY, h:mm A');
    },
    compareDateFromNow(date){
      return moment(date).fromNow()
    },
    closeRejectDialog() {
      this.rejectDialog = false
      this.selected = []
    },
    edit() {
      alert("editing");
    },
    closeDialog(val) {
      if (val) {
        this.showSuccess = true;
      }
      this.dialog = false;
    },
    show(e) {
      e.preventDefault();
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
    assignToRoutee() {
      this.loading = true;
      this.attachDocuments(this.selected)
        .then(() => {
          this.loading = false
          this.route_dialog = true;
        });

    },
    assignToRoute(document) {
      this.documents.push(document)
      this.loading = true;
      this.attachDocuments(this.documents)
        .then(() => {
          this.loading = false
          this.route_dialog = true;
        });

    },
    closeRouteDialog(val) {
      if (val) {
        this.showRouteSuccess = true;
        this.addInitiatedFromRoute(this.selected);
      }
      this.route_dialog = false;
      this.selected = [];
      this.documents = []
    },
    scrollView(){
      if(window.location.hash) {
          var hash = window.location.hash.substring(1); 
          let sampledoc = this.allRoutePendingDocuments.filter(doc => doc.id == hash)
          this.selected = []
          this.selected.push(sampledoc[0])
      }
    }
  },
  computed: mapGetters(["allRoutePendingDocuments"]),
  watch: {
    allRoutePendingDocuments(){
      if(this.allRoutePendingDocuments.length > 0)
        this.scrollView()
    }
  }
};
</script>

<style scoped>
.list-item {
  cursor: pointer;
  font-size: 14px;
}
</style>